export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_-MongoDB_section_01-153ed2dcb6dd471bdf672035204c43b4.jpg";